<p-toast [baseZIndex]="9999" position="top-left"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-5">
        <lib-page-header page-title="REQUISIÇÕES DE MATERIAIS" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
          image-title="assets/img/desktop.png">
        </lib-page-header>
      </div>
      <div class="col-md-7">
        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <a *ngIf="podeIncluir()" [routerLink]="['/requisicoes/novo']"
          class="btn btn-sm btn-outline-success float-right">
          <img src="assets/img/global/plus.png" alt="novo" class="mr-2" title="Incluir" height="20" width="20">Novo
        </a>
      </div>
    </div>
    <hr class="mt-2 mb-4" />
    <div class="row">
      <div class="col-md-6">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <div class="table-responsive">
          <table class="table table-eddy">
            <thead>
              <tr>
                <th scope="col" class="text-center">Nº RRM</th>
                <th scope="col" class="text-center">Data</th>
                <th scope="col">Setor</th>
                <th scope="col">Usuário</th>
                <th scope="col" class="text-center">Status</th>
                <th scope="col" class="text-center">Tipo</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista" class="{{item.status === 'E' ? 'linha-cancelada': ''}}">
                <th scope="row" class="text-center">{{item.id}}</th>
                <td class="text-center">{{item.data_cadastro | date:'dd/MM/yyyy':'GMT'}}</td>
                <td> {{item.setor_almoxarifado?.setor?.nome}} </td>
                <td>{{item.usuario?.nome}}</td>
                <td class="text-center">
                  <span class="badge"
                    [ngClass]="corStatusRequisicao(item.status)">{{tituloStatusRequisicao(item.status)}}</span>
                </td>
                <td class="text-center">
                  <span *ngIf="item.devolucao" class="badge badge-danger">Devolução</span>
                  <span *ngIf="!item.devolucao" class="badge badge-success">Retirada</span>
                </td>
                <td class="text-right">
                  <button *ngIf="!podeIncluir() || item.status !== 'A'" [routerLink]="['/requisicoes', item.id, 'visualizar']"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-secondary mr-2 float-right">
                    <img src="assets/img/global/zoom.png" alt="visualizar" height="18" width="18">
                  </button>
                  <button *ngIf="podeIncluir() && item.status === 'A'" [routerLink]=" ['/requisicoes', item.id, 'editar' ]"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-primary mr-2">
                    <img src="assets/img/global/pencil.png" alt="editar" height="18" width="18">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>